<template>
  <v-row no-gutters class="wrapper" v-if="!loading">
    <v-col
      cols="12"
      md="6"
      v-for="(summary, index) in summaries"
      :key="index"
      class="summary-container mb-5"
    >
      <SummaryBox
        :color="summary.color"
        :icon="summary.icon"
        :label="summary.label"
        :value="summary.total"
      />
    </v-col>
  </v-row>
</template>

<script>
import SummaryBox from './SummaryBox'
import { summary } from '@/services/dashboard'

export default {
  props: {
    id_pengolah: { type: Number, default: null }
  },
  data() {
    return {
      loading: false,
      summaries: []
    }
  },
  components: {
    SummaryBox
  },
  mounted() {
    this.fetchSummary()
  },
  watch: {
    id_pengolah: function(value) {
      this.fetchSummary(value)
    }
  },
  methods: {
    async fetchSummary(id_pengolah = null) {
      this.loading = true
      const { data } = await summary(id_pengolah)
      this.summaries = data
      this.loading = false
    }
  }
}
</script>

<style scoped>
.wrapper {
  margin: 0 -12.5px;
}
.summary-container {
  padding: 0 12.5px;
}
</style>
